<script context="module" lang="ts">
    export interface PrestationProps {
		id: string;
		title: string;
		text: string;
		imagesDesktop: string[];
		imagesMobile: string[];
    }
    
</script>

<script lang="ts">
	
	import {afterUpdate, onMount} from "svelte";
	import {scrollTo} from "../scripts/commons";
	import { storeDomain, storeIsMobile } from "../scripts/store";

	export let props: PrestationProps;

	let isOpenImages: boolean = false;
	let isFirstDisplay: boolean = true;
	let isOpenVideo: boolean = false;
	let positionCarrousel: number = 0;
	let isZoomImage: boolean = false;
	let idImageZoom: string = "slash-1.png";

	onMount(async () => {
		isFirstDisplay = true;
	});

	/**
	 * afterUpdate
	 * Capture du glisser-déposer
	*/
	afterUpdate(() => {
		const slider = <HTMLElement>document.getElementById("carrousel-desktop-"+props.id);
		if (slider != undefined) {
			let isDown = false;
			let startX;
			let scrollLeft;

			slider.addEventListener('mousedown', (e: MouseEvent) => {
				isDown = true;
				slider.classList.add('active');
				startX = e.pageX - slider.offsetLeft;
				scrollLeft = slider.scrollLeft;
			});

			slider.addEventListener('mouseleave', () => {
				isDown = false;
				slider.classList.remove('active');
			});

			slider.addEventListener('mouseup', () => {
				isDown = false;
				slider.classList.remove('active');
			});

			slider.addEventListener('mousemove', (e: MouseEvent) => {
				if(!isDown) return;
				e.preventDefault();
				const x = e.pageX - slider.offsetLeft;
				const walk = (x - startX) * 3; //scroll-fast
				slider.scrollLeft = scrollLeft - walk;
			});

		}

	})

	function goToSide(side) {
		const slider = <HTMLElement>document.getElementById("carrousel-desktop-"+props.id);
		if (side == "begin") {
			if (positionCarrousel > 0) {
				positionCarrousel = positionCarrousel - 600;
			}
		} else {
			positionCarrousel = positionCarrousel + 600;
		}
		slider.scroll({
			top: 0, 
			left: positionCarrousel, 
			behavior: 'smooth'
		});
	}

	function toogleIsOpenImages() {
		isOpenImages = !isOpenImages;
		isFirstDisplay = false;
		scrollTo("carrousel-mobile-images-"+props.id);
	}

	function closeVideo(idVideo: string){
		isOpenVideo = false;
		const video_element = document.getElementById(idVideo);
		if (video_element != null) {
			const innerHTML_before = video_element.innerHTML;
			const innerHTML_after = innerHTML_before.replace("autoplay=1", "autoplay=0");
			video_element.innerHTML = innerHTML_after;
		}
	}

	function openVideo(idVideo: string){
		isOpenVideo = true;
		const video_element = document.getElementById(idVideo);
		if (video_element != null) {
			const innerHTML_before = video_element.innerHTML;
			const innerHTML_after = innerHTML_before.replace("autoplay=0", "autoplay=1");
			video_element.innerHTML = innerHTML_after;
		}
	}

	function closeImage() {
		idImageZoom = "";
		isZoomImage = false;
	}

	function openImage(name: string){
		idImageZoom = name;
		isZoomImage = true;
	}

</script>

<style lang="scss">

	.video {
		position: fixed;
		top: 0;
		left: 0;
		height: 100vh;
		width: 100vw;
		visibility: hidden;
		opacity: 0;
		transition: visibility 0.1s, opacity 0.1s linear;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		&__amanagements {
			background-color: $color-bordeau-instit;
		}
		&__services {
			background-color: $color-bleu-instit;
		}
		&__bg {
			transition: visibility 1s, opacity 0.5s linear;
			visibility: visible;
			opacity: 0.8;
			z-index: 1000;
		}
		&__inside {
			top: 40%;
			left: 1%;
			width: 98%;
			height: 40%;
			visibility: visible;
			opacity: 1;
			z-index: 1001;
		}
	}

	.zoom {
		display: none;
	}

    .prestation {
        display: grid;
		grid-template-areas: 
			"habillage habillage vide1"
			"carrousel carrousel carrousel"
			"vide2 plus plus";
		grid-template-rows: 40px 1fr 40px;
		grid-template-columns: 60% 20% 20%;
        width: 100%;
		margin: 0 0 $header-height 0;
		&__habillage {
			grid-area: habillage;
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			&__slash {
				width: 66px;
				height: 40px;
			}
			&__line {
				margin-right: -30px;
				margin-left: -$contener-marge-small;
				width: 100%;
				&__services {
					border-top: 1px solid $color-bleu-clair-instit;
				}
				&__amenagements {
					border-top: 1px solid $color-orange-dde;
				}
			}
		}
		&__plus__mobile {
			grid-area: plus;
			text-align: right;
			display: flex;
			flex-direction: row;
			justify-content: flex-end;
			align-items: center;
			cursor: pointer;
			&__text {
				&__up {
					display: none;
					&__open {
						display: block;
					}
				}
				&__down {
					display: none;
					&__open {
						display: block;
					}
				}
			}
			&__arrow {
				padding: 0 15px 0 15px;
				&__up {
					display: none;
					&__open {
						display: block;
					}
				}
				&__down {
					display: none;
					&__open {
						display: block;
					}
				}
			}
		}
		&__plus__desktop {
			display: none;
		}
		&__carrousel__mobile {
			grid-area: carrousel;
			&__text {
				margin: 30px 0 0 0;
			}
			&__items {
				height: auto;
				max-height: 0px;
				overflow: hidden;
				animation-name: closeImages;
				animation-duration: 1s;
				animation-delay: 0s;
				animation-fill-mode: forwards;
				animation-timing-function: ease-in-out;
				&__open {
					width: 100%;
					height: auto;
					max-height: 10000px;
					overflow: hidden;
					animation-name: openImages;
					animation-duration: 1s;
					animation-delay: 0s;
					animation-timing-function: ease-in-out;
					animation-fill-mode: forwards;
				}
			}
			&__item1 {
				display: block;
				height: auto;
				width: 100%;
			}
			&__item {
				margin: 15px 0 0 0;
				display: block;
				height: auto;
				width: 100%;
			}
		}
		&__carrousel__desktop {
			display: none;
		}
		&__anchor {
			scroll-margin-top: $header-height;
		}
	}

    @keyframes openImages {
        0% {
            max-height: 0px;
        }
        100% {
            max-height: 10000px;
        }
    }

    @keyframes closeImages {
        0% {
            max-height: 10000px;
        }
        100% {
            max-height: 0px;
        }
    }

	@include large {

		.video {
			&__inside {
				top: 10%;
				left: 10%;
				width: 80%;
				height: 80%;
				visibility: visible;
				opacity: 1;
				z-index: 1001;
			}
		}

		.zoom {
			position: fixed;
			top: 0;
			left: 0;
			height: 100vh;
			width: 100vw;
			visibility: hidden;
			opacity: 0;
			transition: visibility 0.1s, opacity 0.1s linear;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			&__amenagements {
				background-color: $color-bordeau-instit;
			}
			&__services {
				background-color: $color-bleu-instit;
			}
			&__bg {
				transition: visibility 1s, opacity 0.5s linear;
				visibility: visible;
				opacity: 0.8;
				z-index: 1000;
			}
			&__inside {
				top: 10%;
				left: 10%;
				width: 80%;
				height: 80%;
				visibility: visible;
				opacity: 1;
				z-index: 1001;
			}
			&__img {
				height: 100%;
				display: none;
				&__display {
					display: block;
				}
			}
		}

        .prestation {
			grid-template-areas: 
				"habillage plus"
				"carrousel carrousel";
			grid-template-columns: 33% 1fr;
			grid-template-rows: 40px 1fr;
			column-gap: 30px;
			row-gap: 30px;
			&__habillage {
				&__line {
					margin-left: -$contener-marge-large;
					width: calc($contener-marge-large-pourcent / 2);
				}
			}
			&__plus__mobile {
				display: none;
			}
			&__plus__desktop {
				grid-area: plus;
				text-align: right;
				display: flex;
				flex-direction: row;
				justify-content: flex-end;
				align-items: center;
				cursor: pointer;
				height: 16px;
				&__arrow {
					padding: 0 15px 0 15px;
					height: 100%;
					background-repeat: no-repeat;
					background-position: center;
					background-size: contain;
					&__beg {
						&__services {
							background-image: url("../images/arrow-beg-services.png");
						}
						&__amenagements {
							background-image: url("../images/arrow-beg-amenagements.png");
						}
						&:hover {
							background-image: url("../images/arrow-beg-white.png");
						}
					}
					&__end {
						&__services {
							background-image: url("../images/arrow-end-services.png");
						}
						&__amenagements {
							background-image: url("../images/arrow-end-amenagements.png");
						}
						&:hover {
							background-image: url("../images/arrow-end-white.png");
						}
					}
				}
				&__text {
					&:hover ~ .prestation__plus__desktop__arrow__end {
						background-image: url("../images/arrow-end-white.png");
					}
				}
			}
			&__carrousel__mobile {
				display: none;
			}
			&__carrousel__desktop {
				grid-area: carrousel;
				display: block;
				position: relative;
				width: 100%;
				overflow: hidden;
				white-space: nowrap;
				user-select: none;
				-webkit-user-select: none;
				-ms-user-select: none;
				cursor: all-scroll;
				&__text {
					display: inline-block;
					width: 33%;
					overflow-wrap: break-word;
					white-space: normal;
					margin: 0;
				}
				&__bg {
					display: inline-block;
					margin: 0 0 0 30px;
					vertical-align: top;
					&__services {
						background-color: #343793;
					}
					&__amenagements {
						background-color: $color-orange-dde;
					}
				}
				&__item {
					display: inline-block;
					-webkit-user-drag: none;
					vertical-align: top;
					opacity: 0.7;
					transition: all;
					transition-duration: 1s;
					max-width: 284px;
					&:hover {
						opacity: 1;
					}
					&__video {
						width: 284px;
						height: 189px;
						opacity: 1;
						&__enrobes {
							background-image: url("../images/amenagements/enrobes/prestation-enrobes-1.png");
							background-position: center;
							background-size: contain;
							&:hover {
								background-image: url("../images/amenagements/enrobes/prestation-enrobes-1-hover.png");
								background-position: center;
								background-size: contain;
							}
						}
						&__balayage {
							background-image: url("../images/services/balayage/prestation-balayage-0.png");
							background-position: center;
							background-size: contain;
							&:hover {
								background-image: url("../images/services/balayage/prestation-balayage-0-hover.png");
								background-position: center;
								background-size: contain;
							}
						}
					}
				}
			}
        }
	}

	@include extra-large {
        .prestation {
			&__habillage {
				&__line {
					margin-left: -$contener-marge-large;
					width: calc($contener-marge-large-pourcent / 2);
					&__ext {
						position: absolute;
						margin-left: -1000px;
						width: 1000px;
						&__services {
							border-bottom: 1px solid $color-bleu-clair-instit;
						}
						&__amenagements {
							border-bottom: 1px solid $color-orange-dde;
						}
					}
				}
			}
        }
	}

	@keyframes flou {
        0% {
			opacity: 1;
        }
        50% {
			opacity: 0.8;
		}
        100% {
			opacity: 1;
		}
    }

</style>

{#if (props.id == "enrobes")}
<div class="video video_amenagements" class:video__bg={isOpenVideo}  on:click={() => closeVideo("idVideoEnrobes")} on:keydown={() => closeVideo("idVideoEnrobes")}>
</div>
<div id="idVideoEnrobes" class="video video_amenagements" class:video__inside={isOpenVideo}>
	<iframe width="100%" height="100%" src="https://www.youtube.com/embed/hJX6LaOJ8Fw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
{/if}
{#if (props.id == "balayage")}
<div class="video video_services" class:video__bg={isOpenVideo}  on:click={() => closeVideo("idVideoBalayage")} on:keydown={() => closeVideo("idVideoBalayage")}>
</div>
<div id="idVideoBalayage" class="video video_services" class:video__inside={isOpenVideo}>
	<iframe width="100%" height="100%" src="https://www.youtube.com/embed/1c3re0vjGJM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
{/if}
<div class="zoom" class:zoom__amenagements={$storeDomain == "amenagements"} class:zoom__services={$storeDomain == "services"} class:zoom__bg={isZoomImage} on:click={() => closeImage()} on:keydown={() => closeImage()}>
</div>
<div class="zoom" class:zoom__amenagements={$storeDomain == "amenagements"} class:zoom__services={$storeDomain == "services"} class:zoom__inside={isZoomImage} class:zoom__bg={isZoomImage} on:click={() => closeImage()} on:keydown={() => closeImage()}>
	<img class="zoom__img" class:zoom__img__display={isZoomImage} src="../images/{idImageZoom}" title={props.title} alt={props.title} >
</div>

<div id="prestation-{props.id}" class="prestation">
	<div class="prestation__habillage">
		<div class="prestation__habillage__line" class:prestation__habillage__line__services={$storeDomain == "services"}  class:prestation__habillage__line__amenagements={$storeDomain == "amenagements"}>&nbsp;</div>
		<div class="prestation__habillage__line__ext" class:prestation__habillage__line__ext__services={$storeDomain == "services"}  class:prestation__habillage__line__ext__amenagements={$storeDomain == "amenagements"}></div>
		{#if ($storeDomain == "services")}
		<img class="prestation__habillage__slash" src="../images/slash-services.png" alt="slash services">
		{:else}
		<img class="prestation__habillage__slash" src="../images/slash-amenagements.png" alt="slash amenagements">
		{/if}
	</div>
	<div class="prestation__plus__mobile">
		<div class="prestation__plus__mobile__text__down" class:prestation__plus__mobile__text__down__open={!isOpenImages} on:click={() => toogleIsOpenImages()} on:keydown={() => toogleIsOpenImages()}>
			+&nbsp;D'IMAGES
		</div>
		{#if ($storeDomain == "services")}
			<img class="prestation__plus__mobile__arrow prestation__plus__mobile__arrow__down" class:prestation__plus__mobile__arrow__down__open={!isOpenImages} src="../images/arrow-down-services.png" on:click={() => toogleIsOpenImages()} on:keydown={() => toogleIsOpenImages()} alt="down">
		{:else}
			<img class="prestation__plus__mobile__arrow prestation__plus__mobile__arrow__down" class:prestation__plus__mobile__arrow__down__open={!isOpenImages} src="../images/arrow-down-amenagements.png" on:click={() => toogleIsOpenImages()} on:keydown={() => toogleIsOpenImages()} alt="down">
		{/if}
		<div class="prestation__plus__mobile__text__up" class:prestation__plus__mobile__text__up__open={isOpenImages} on:click={() => toogleIsOpenImages()} on:keydown={() => toogleIsOpenImages()}>
			-&nbsp;D'IMAGES
		</div>
		{#if ($storeDomain == "services")}
			<img class="prestation__plus__mobile__arrow prestation__plus__mobile__arrow__up" class:prestation__plus__mobile__arrow__up__open={isOpenImages} src="../images/arrow-up-services.png" on:click={() => toogleIsOpenImages()} on:keydown={() => toogleIsOpenImages()} alt="up">
		{:else}
			<img class="prestation__plus__mobile__arrow prestation__plus__mobile__arrow__up" class:prestation__plus__mobile__arrow__up__open={isOpenImages} src="../images/arrow-up-amenagements.png" on:click={() => toogleIsOpenImages()} on:keydown={() => toogleIsOpenImages()} alt="up">
		{/if}
	</div>
	<div class="prestation__plus__desktop">
		<div class="prestation__plus__desktop__arrow prestation__plus__desktop__arrow__beg" class:prestation__plus__desktop__arrow__beg__services={$storeDomain == "services"} class:prestation__plus__desktop__arrow__beg__amenagements={$storeDomain == "amenagements"} on:click={() => goToSide("begin")} on:keydown={() => goToSide("begin")}>
			&nbsp;
		</div>
		<div class="prestation__plus__desktop__text" on:click={() => goToSide("end")} on:keydown={() => goToSide("end")}>
			+&nbsp;D'IMAGES
		</div>
		<div class="prestation__plus__desktop__arrow prestation__plus__desktop__arrow__end" class:prestation__plus__desktop__arrow__end__services={$storeDomain == "services"} class:prestation__plus__desktop__arrow__end__amenagements={$storeDomain == "amenagements"} on:click={() => goToSide("end")} on:keydown={() => goToSide("end")}>
			&nbsp;
		</div>
	</div>
	{#if ($storeIsMobile)}
	<div id="carrousel-mobile-{props.id}" class="prestation__carrousel__mobile">
		<div class="prestation__carrousel__mobile__text">
			<div class="font-txt-courant-bold">{props.title}</div>
			<div>
				{@html props.text}
			</div>
		</div>
		<div id="carrousel-mobile-images-{props.id}" class="prestation__anchor"></div>
		{#if (props.id == "enrobes")}
			<img class="prestation__carrousel__mobile__item prestation__carrousel__mobile__item1" src="../images/{props.imagesMobile[0]}" alt="carrousel" on:click={() => openVideo("idVideoEnrobes")} on:keydown={() => openVideo("idVideoEnrobes")}>
		{:else if (props.id == "balayage")}
			<img class="prestation__carrousel__mobile__item prestation__carrousel__mobile__item1" src="../images/{props.imagesMobile[0]}" alt="carrousel" on:click={() => openVideo("idVideoBalayage")} on:keydown={() => openVideo("idVideoBalayage")}>
		{:else}
			<img class="prestation__carrousel__mobile__item prestation__carrousel__mobile__item1" src="../images/{props.imagesMobile[0]}" alt="carrousel">
		{/if}
		{#if (!isFirstDisplay)}
		<div class:prestation__carrousel__mobile__items={!isOpenImages} class:prestation__carrousel__mobile__items__open={isOpenImages}>
			{#each props.imagesMobile as image, index}
			{#if (index != 0)}
				<img class="prestation__carrousel__mobile__item" src="../images/{image}" alt="carrousel">
			{/if}
			{/each}
		</div>
		{/if}
	</div>
	{:else}
	<div id="carrousel-desktop-{props.id}" class="prestation__carrousel__desktop">
		<div class="prestation__carrousel__desktop__text">
			<div class="font-txt-courant-bold">{props.title}</div>
			<div>
				{@html props.text}
			</div>
		</div>
		{#each props.imagesDesktop as image, index}
			<span class="prestation__carrousel__desktop__bg" class:prestation__carrousel__desktop__bg__services={$storeDomain == "services"} class:prestation__carrousel__desktop__bg__amenagements={$storeDomain == "amenagements"}>
				{#if (index == 0 && props.id == "enrobes")}
					<div class="prestation__carrousel__desktop__item prestation__carrousel__desktop__item__video prestation__carrousel__desktop__item__video__enrobes" on:click={() => openVideo("idVideoEnrobes")} on:keydown={() => openVideo("idVideoEnrobes")} draggable="false">&nbsp;</div>
				{:else if (index == 0 && props.id == "balayage")}
					<div class="prestation__carrousel__desktop__item prestation__carrousel__desktop__item__video prestation__carrousel__desktop__item__video__balayage" on:click={() => openVideo("idVideoBalayage")} on:keydown={() => openVideo("idVideoBalayage")} draggable="false">&nbsp;</div>				
				{:else}
					<img id={image} class="prestation__carrousel__desktop__item" on:click={() => openImage(image)} on:keydown={() => openImage(image)} src="../images/{image}" title={props.title} alt={props.title} draggable="false">
				{/if}
			</span>
		{/each}
	</div>
	{/if}
</div>
